import $ from 'jquery';

// shifts the label body horizontally, so it stays inside .object-highlight instead of overflowing its edges
function fitLabelBody($label) {
    var container = $label.closest('.object-highlight')[0];
    if(!container) {
        return;
    }
    var bounds = container.getBoundingClientRect();

    $label.find('.object-highlight__label-body').each(function() {
        this.style.setProperty('--object-highlight-shift', '0px');
        var rect = this.getBoundingClientRect();
        // hidden via display: none (e.g. the --mobile variant on desktop)
        if(rect.width === 0) {
            return;
        }

        var shift = 0;
        if(rect.right > bounds.right) {
            shift = bounds.right - rect.right;
        }
        if(rect.left + shift < bounds.left) {
            shift = bounds.left - rect.left;
        }
        this.style.setProperty('--object-highlight-shift', shift + 'px');
    });
}

function activateLabel($label) {
    $label.addClass('object-highlight__label--active');
    fitLabelBody($label);
}

$('.object-highlight__button').on('click', function(e) {
    $('.object-highlight__label').removeClass('object-highlight__label--active');
    if($(this).attr('href') === '#') {
        e.preventDefault();
        activateLabel($(this).parents('.object-highlight__label'));
    }
});

$('.object-highlight__marker').on('click', function(e) {
    var href = $(this).siblings('.object-highlight__button').attr('href');
    if($(window).width() >= 768) {
        if(href === '#') {
            e.preventDefault();
        }
        else {
            window.open(href);
        }
    }
    else {
        e.preventDefault();
    }
    $('.object-highlight__label').removeClass('object-highlight__label--active');
    activateLabel($(this).parents('.object-highlight__label'));

});

$('.object-highlight__button').on('mouseenter', function(e) {
    if($(window).width() >= 1280) {
        $('.object-highlight__label').removeClass('object-highlight__label--active');
        if($(this).attr('href') === '#') {
            e.preventDefault();
            activateLabel($(this).parents('.object-highlight__label'));
        }
    }
});

$(window).on('resize', function() {
    $('.object-highlight__label--active').each(function() {
        fitLabelBody($(this));
    });
});

$('.object-highlight__label-wrap').on('mouseleave', function() {
    if($(window).width() >= 1280) {
        $('.object-highlight__label').removeClass('object-highlight__label--active');
    }
});

$(document).on('click', function(event) {
    if (!$(event.target).closest('.object-highlight__button').length && !$(event.target).closest('.object-highlight__marker').length) {
        $('.object-highlight__label').removeClass('object-highlight__label--active');
    }
});


